import React, { useState } from "react";
import {
  Typography,
  Flex,
  Table,
  Input,
  Button,
  Modal,
} from "antd";
import { getDealRedeemDetails } from "./DealRedeemColumns";
import { useGetAllDealRedemptionsQuery } from "../../../api/admin/webshop/dealRedeems/DelaRedeemApi";
import { DealRedeemItem } from "../../../api/admin/webshop/dealRedeems/DealRedeemItem";
import { RedemptionReport } from "./RedemptionReport";

export default function DealRedemptionPage() {

    const { data: apiData, error, isFetching, refetch } = useGetAllDealRedemptionsQuery();
    const [searchQuery, setSearchQuery] = useState("");
    const [showReport, setShowReport] = useState(false);

    // Transform API data to include keys for table
    const transformedData: DealRedeemItem[] = React.useMemo(() => {
      console.log("apidata", apiData)
      if (!apiData) return [];
      
      let data = [...apiData];
      
      if (searchQuery) {
        const lowerQuery = searchQuery.toLowerCase();
        data = data.filter((item: any) => {
          const name = item.name || (item.firstName ? `${item.firstName} ${item.lastName || ""}` : "");
          return (
            (item.orderId && item.orderId.toLowerCase().includes(lowerQuery)) ||
            (item.promoCode && item.promoCode.toLowerCase().includes(lowerQuery)) ||
            (item.email && item.email.toLowerCase().includes(lowerQuery)) ||
            (name && name.toLowerCase().includes(lowerQuery))
          );
        });
      }

      // sort api data based on status alphabetically
      return data.sort((a, b) => b.createdAt.localeCompare(a.createdAt))
    }, [apiData, searchQuery]);


    const handleViewDetails = (record: DealRedeemItem) => {
      console.log("record", record);
    }
    
  if (showReport) {
    return (
      <Flex gap={16} vertical>
        <Flex justify="space-between" align="center">
          <Typography.Title level={2} style={{ margin: 0 }}>Redemption Report</Typography.Title>
          <Button onClick={() => setShowReport(false)}>Back to Details</Button>
        </Flex>
        <RedemptionReport data={apiData || []} />
      </Flex>
    );
  }

  return (
    <Flex gap={8} vertical>
     
      <Flex justify="space-between" align="end">
        <Flex gap={16} align="center">
          <Typography.Title level={2} style={{ margin: 0 }}>Deals Redeemption Details</Typography.Title>
          <Button type="primary" onClick={() => setShowReport(true)}>View Report</Button>
        </Flex>
        <Input.Search
          placeholder="Search by order, promo, name, email"
          allowClear
          onChange={(e) => setSearchQuery(e.target.value)}
          style={{ width: 300, marginBottom: 16 }}
        />
      </Flex>
      <Table
        rowKey={(record) => record.promoCode}
        dataSource={transformedData}
        loading={isFetching}
        columns={getDealRedeemDetails(handleViewDetails)}
      />

    </Flex>
  );
}
